export default __webpack_public_path__ + "static/media/corporateImg2.f1b1ecec.png";